// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1_yaA","cls2":"News-cls2_QEy News-cls1_yaA"};